import { Stack } from '@mui/material';
import { ExpandableContentWrapper } from 'components/shared';
import {
  HiroProvider,
  HiroPerInstPersistentSettings,
} from 'components/hiro/HiroProvider';
import { HiroChartContainer } from 'components/hiro/HiroChartContainer';
import { CanvasContentId } from 'types/canvas';

interface CanvasHiroChartProps {
  id: number;
  config: Partial<HiroPerInstPersistentSettings>;
  onConfigChange: (patch: Partial<HiroPerInstPersistentSettings>) => void;
}

const CanvasHiroChart = ({
  id,
  config,
  onConfigChange,
}: CanvasHiroChartProps) => {
  const expandableContentButtonType = `${CanvasContentId.HIRO_CHART}-${id}`;

  return (
    <ExpandableContentWrapper
      type={expandableContentButtonType}
      styleOverrides={{ p: 1, height: '100%' }}
    >
      <HiroProvider
        mode="canvas"
        config={config}
        onConfigChange={onConfigChange}
        canvasId={id}
        expandableContentButtonType={expandableContentButtonType}
      >
        <Stack
          direction="column"
          spacing={1}
          sx={{ height: '100%', width: '100%' }}
        >
          <HiroChartContainer />
        </Stack>
      </HiroProvider>
    </ExpandableContentWrapper>
  );
};

export default CanvasHiroChart;
